import openMobileAppLink from './openMobileAppLink';

export const buildReturnPath = (teamId, result = 'free') =>
  `subscription-return?teamId=${encodeURIComponent(teamId)}&result=${result}`;

export const isAppSource = (search) => new URLSearchParams(search).get('source') === 'app';

export const returnToApp = (teamId, result) => openMobileAppLink(buildReturnPath(teamId, result));
